.modalBody {
  width: 650px;
}

.header {
  align-items: flex-start;
}

.headerContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.media {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
